import { prefixZero } from "./StringUtil";

export function getDBDate(dateValue) {

    var date = new Date(dateValue);
    var month = parseInt(date.getMonth()) + 1;
    var day = date.getDate();

    return date.getFullYear() + "-" + prefixZero(month,2) + "-" + prefixZero(day,2);
}

export function getDateObject(dateValue) {

    return new Date(dateValue);
}